import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loading = () => {
  return (
    <div className="d-flex h-100" style={{ alignItems: 'center', justifyContent: 'center' }}>
      <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#003a61' }} spin />} />
    </div>
  );
};

export default Loading;
